import { render, staticRenderFns } from "./SKUGroups.vue?vue&type=template&id=641602ea"
import script from "./SKUGroups.vue?vue&type=script&lang=js"
export * from "./SKUGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports